import React, { Fragment } from "react";
import Footer from "../../footer";
import { Prompt, Redirect } from "react-router-dom";
import Question from "./QuestionsEditExam.jsx";
import { connect } from "react-redux";
import Ball from "../../../assets/Ball.svg";
import SweetAlert from "react-bootstrap-sweetalert";
import InputRange from "react-input-range";
import "react-input-range/lib/css/index.css";
import axiosInstance from "../../../store/services/AxiosService";
import SelectClass from "../component/SelectClassComponent.js";
import BankSoalModal from "../component/BankSoalModal.jsx";
import { loadCaseWillEdit, editNameCase, setNameCasePart, setScoreWeight, editRandomQuestion, editRandomAnswer, handleSelectTypeCasePilgan, handleSelectTypeCaseEssay, addCasePart, deleteItem, changeStatusEdit, editCaseSensitife, handleSelectTypeCaseMenjodohkan, handleSelectClass } from "../../../store/actions/index";


class EditCase extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            alertSubmit: null,
            taskDone: false,
            caseStillEmpty: false,
            listClass: null,
            classGradeId: null,
            showBankSoalModal: false,
            listKd: null,
            tipePenilaian: 'CP', // default
        };
    }

    fetchDataCase = () => {
        axiosInstance.get(`/cases/${this.props.match.params.case_id}?type_user=teacher`).then((res) => {
            const data = res.data;
            const case_parts = Object.values(data.case_parts).map((element, index) => {
                let random_choice_order = element.random_choice_order;
                if (element.type_name === 'menjodohkan') {
                    if (random_choice_order === null || random_choice_order === undefined || random_choice_order === 1 || random_choice_order === "1" || random_choice_order === true) {
                        random_choice_order = "1";
                    }
                }
                return {
                    ...element,
                    random_choice_order: random_choice_order,
                    key: index + 1,
                    case_questions: Object.values(element.case_questions).map((item, index) => {
                        return {
                            ...item,
                            key: index + 1,
                            status_img: item.file_attached === null ? 0 : 1,
                            kd_id: item.kd_units?.api_kd_id || null,
                            kd_unit_id: item.kd_units?.kompetensi_dasar_detail_id || item.kd_units?.api_unit_id || null,
                            kd_description: item.kd_units?.kd_description || null,
                            kd_unit_description: item.kd_units?.unit_description || null,

                            case_choices: Object.values(item.case_choices).map((member, index) => {
                                return {
                                    ...member,
                                    key: index + 1,
                                    status_img: member.file_attached === null ? 0 : 1,
                                };
                            }),
                            case_choices_answers: item.case_choices_answers ? Object.values(item.case_choices_answers).map((member, index) => {
                                return {
                                    ...member,
                                    key: index + 1,
                                    status_img: member.file_attached === null ? 0 : 1,
                                };
                            }) : [],
                        };
                    }),
                };
            });

            const resolvedClassGradeId = data.schedules?.api_class_id ? Number(data.schedules.api_class_id) : (data.api_class_id ? Number(data.api_class_id) : null);
            const cases = {
                id: data.id,
                name: data.name,
                school_id: data.school_id,
                course_id: data.api_course_id,
                teacher_id: data.api_teacher_id,
                class_grade_id: resolvedClassGradeId,
                class_id: data.api_class_id || null,
                class_label: data.class_label || null,
            };
            this.props.loadCaseWillEdit(cases, case_parts);
            this.setState({ classGradeId: resolvedClassGradeId });
            localStorage.setItem("caseWillEdit", JSON.stringify(res.data));

            if (data.api_course_id && resolvedClassGradeId && data.school_id) {
                this.fetchKdList(data.api_course_id, resolvedClassGradeId, data.school_id);
                this.fetchCptpSetting(data.school_id);
            }
        });
    };

    fetchCptpSetting = (schoolId) => {
        const targetSchoolId = schoolId || this.props.schoolId || this.props.cases?.school_id;
        if (!targetSchoolId) return;
        axiosInstance.get(`/kompetensi-dasar/cptp-setting/school/${targetSchoolId}`)
            .then((r) => {
                this.setState({ tipePenilaian: r.data?.tipe_penilaian || 'CP' });
            })
            .catch(() => {
                this.setState({ tipePenilaian: 'CP' });
            });
    };

    fetchKdList = (courseId, classGradeId, schoolId) => {
        if (!courseId || !classGradeId || !schoolId || classGradeId === 'null' || classGradeId === 'undefined') return;
        if (this._isFetchingKd) return;
        this._isFetchingKd = true;
        const url = `/kompetensi-dasar/course/${courseId}/class/${classGradeId}/school/${schoolId}`;
        axiosInstance.get(url).then(res => {
            this._isFetchingKd = false;
            this.setState({ listKd: res.data || [] });
        }).catch(err => {
            this._isFetchingKd = false;
            console.warn("Failed to fetch KD list:", err);
            this.setState({ listKd: [] });
        });
    };

    handleClassChange = (selectedClass) => {
        this.props.handleSelectClass(selectedClass);
        const classGradeId = selectedClass?.class_grade_id ?? selectedClass?.value;
        this.setState({ classGradeId: classGradeId });
        const courseId = this.props.cases?.course_id || this.props.match.params.course_id;
        const schoolId = this.props.schoolId || this.props.cases?.school_id;
        if (courseId && classGradeId && schoolId) {
            this.fetchKdList(courseId, classGradeId, schoolId);
        }
    };

    componentDidUpdate(prevProps) {
        const currentCourse = this.props.cases?.course_id || this.props.match.params.course_id;
        const currentGrade = this.props.cases?.class_grade_id;
        const currentSchool = this.props.schoolId || this.props.cases?.school_id;

        const prevCourse = prevProps.cases?.course_id || prevProps.match.params.course_id;
        const prevGrade = prevProps.cases?.class_grade_id;

        // Only trigger when course or grade level actually changes
        if (
            (currentGrade && prevGrade !== currentGrade) ||
            (currentCourse && prevCourse !== currentCourse)
        ) {
            this.fetchKdList(currentCourse, currentGrade, currentSchool);
        }

        if (
            (this.props.schoolId && prevProps.schoolId !== this.props.schoolId) ||
            (this.props.cases?.school_id && prevProps.cases?.school_id !== this.props.cases?.school_id)
        ) {
            this.fetchCptpSetting(currentSchool);
        }
    }

    async componentDidMount() {
        await this.fetchDataCase();

        const isUserAdmin = [1, 6, 7].includes(Number(this.props.roleId));
        const queryParams = `?is_admin=${isUserAdmin}&role_id=${this.props.roleId}&teacher_id=${this.props.userId}`;

        axiosInstance.get(`/classes/teacher/${this.props.userId}/school/${this.props.schoolId}${queryParams}`).then((res) => {
            const list = res.data || [];
            const formattedClasses = Object.values(list).map((item) => ({
                value: item.class_id,
                class_id: item.class_id,
                class_grade_id: item.class_grade_id,
                label: item.class_label,
            }));
            formattedClasses.sort((a, b) => {
                const gradeA = a.class_grade_id ?? 0;
                const gradeB = b.class_grade_id ?? 0;
                if (gradeA !== gradeB) {
                    return gradeA - gradeB;
                }
                return (a.label || "").localeCompare(b.label || "", undefined, { numeric: true, sensitivity: 'base' });
            });
            this.setState({ listClass: formattedClasses });
        }).catch((err) => {
            console.warn("Failed to fetch classes:", err);
            this.setState({ listClass: [] });
        });

        // Fetch CP/TP Setting
        this.fetchCptpSetting(this.props.schoolId);

        // Fetch KD List
        if (this.props.cases && this.props.cases.course_id && this.props.cases.class_grade_id && this.props.schoolId) {
            let class_grade = this.props.cases.class_grade_id !== undefined ? this.props.cases.class_grade_id : this.props.match.params.class_grade_id;
            let url = `/kompetensi-dasar/course/${this.props.cases.course_id}/class/${class_grade}/school/${this.props.schoolId}`;
            axiosInstance.get(url).then(res => {
                this.setState({ listKd: res.data });
            }).catch(err => {
                console.warn("Failed to fetch KD list:", err);
            });
        }
    }

    addItem = (e) => {
        console.log("this.props.currentItemTypeCase edit", this.props.currentItemTypeCase);

        e.preventDefault();
        if (this.props.currentItemTypeCase.text === "") {
            return false;
        } else {
            this.props.addCasePart(this.props.currentItemTypeCase, this.props.cases.name);
        }
        this.setState({
            isBtnDisable: true,
        });
    };

    deleteItem = (e, key) => {
        e.preventDefault();
        var removeIndex = this.getIndex(key, this.props.caseWillEdit);
        this.props.deleteCasePart(removeIndex);
    };

    handleSubmit(e) {
        e.preventDefault();
        const getAlert = () => (
            <SweetAlert custom showCancel showCloseButton confirmBtnText="Ya" cancelBtnText="Tidak" confirmBtnBsStyle="primary" cancelBtnBsStyle="light" title="Simpan Soal Ini?" onConfirm={() => this.submitExam()} onCancel={() => this.setState({ alertSubmit: null })}>
                Klik Ya untuk menyimpan soal ini
            </SweetAlert>
        );

        const alertScoreWeightError = () => (
            <SweetAlert warning title="Proses Gagal!" onConfirm={() => this.setState({ alertSubmit: null })} onCancel={() => this.setState({ alertSubmit: null })}>
                Mohon maaf, tidak bisa disimpan karena ada bagian soal yang memiliki bobot 0. Harap lengkapi semua bobot nilai terlebih dahulu.
            </SweetAlert>
        );

        let errorMessages = [];
        let errNullValue = false;
        const isCptpOptional = this.state.listKd && this.state.listKd.length === 0;

        try {
            Object.values(this.props.caseWillEdit).forEach((element, pIndex) => {
                const partName = element.name || `Bagian ${pIndex + 1}`;
                Object.values(element.case_questions).forEach((item, qIndex) => {
                    const qNumber = qIndex + 1;
                    if (!item.question || item.question.trim() === "") {
                        errNullValue = true;
                        errorMessages.push(`<b>${partName} - Soal No. ${qNumber}</b>: Teks pertanyaan kosong.`);
                    }
                    if (!isCptpOptional) {
                        if (!item.kd_id) {
                            errNullValue = true;
                            errorMessages.push(`<b>${partName} - Soal No. ${qNumber}</b>: Capaian Pembelajaran (CP) belum dipilih.`);
                        }
                        if (this.state.tipePenilaian === 'TP' && !item.kd_unit_id) {
                            errNullValue = true;
                            errorMessages.push(`<b>${partName} - Soal No. ${qNumber}</b>: Tujuan Pembelajaran (TP) belum dipilih.`);
                        }
                    }
                    if (element.type_name === "pilihan ganda") {
                        let hasEmptyChoice = false;
                        Object.values(item.case_choices).forEach((i) => {
                            if (!i.value || (typeof i.value === 'string' && !i.value.trim())) {
                                hasEmptyChoice = true;
                                errNullValue = true;
                            }
                        });
                        if (hasEmptyChoice) {
                            errorMessages.push(`<b>${partName} - Soal No. ${qNumber}</b>: Terdapat opsi pilihan ganda yang kosong.`);
                        }
                    }
                });
            });
        } catch (e) {
            errNullValue = true;
            errorMessages.push("Terjadi kesalahan saat validasi data soal.");
        }

        let hasZeroWeight = false;
        Object.values(this.props.caseWillEdit).forEach((element) => {
            if (Number(element.score_weight) === 0 || !element.score_weight) {
                hasZeroWeight = true;
            }
        });

        if (errorMessages.length > 0 || errNullValue) {
            const errorList = (
                <div style={{ textAlign: "left", maxHeight: "300px", overflowY: "auto", fontSize: "14px", marginTop: "15px" }}>
                    <ul style={{ paddingLeft: "20px", margin: 0 }}>
                        {errorMessages.map((msg, index) => (
                            <li key={index} dangerouslySetInnerHTML={{ __html: msg }} style={{ marginBottom: "5px" }}></li>
                        ))}
                    </ul>
                </div>
            );

            const alertValidationError = () => (
                <SweetAlert 
                    warning 
                    title="Oops! Ada yang terlewat" 
                    onConfirm={() => this.setState({ alertSubmit: null })} 
                    onCancel={() => this.setState({ alertSubmit: null })}
                >
                    <p style={{ margin: 0 }}>Mohon lengkapi bagian berikut sebelum menyimpan:</p>
                    {errorList}
                </SweetAlert>
            );

            this.setState({
                alertSubmit: alertValidationError(),
                caseStillEmpty: true,
            });
        } else if (hasZeroWeight) {
            this.setState({
                alertSubmit: alertScoreWeightError(),
            });
        } else {
            this.setState({
                alertSubmit: getAlert(),
            });
        }
    }

        handleDeleteImage(fileToDelete) {
        const url = "/files/delete";
        if (fileToDelete.length === 0) {
            fileToDelete.push("");
        }
        const dataToDel = { file_name: fileToDelete };
        axiosInstance
            .post(url, dataToDel)
            .then((r) => { })
            .catch((error) => {
                alert(`Proses delete gagal => ${error.message}`);
            });
    }

    deleteImageToSave(arrContent, arrAllFile) {
        // console.log(arrContent, arrAllFile);
        let arrLama = arrAllFile;
        arrContent.map((item) => {
            // console.log(item);
            return (arrLama = arrLama.filter((i) => i !== item));
        });
        // console.log(arrLama);
        this.handleDeleteImage(arrLama);
    }

    submitExam() {
        let arrImgContent = [];
        Object.values(this.props.caseWillEdit).map((part) => {
            Object.values(part.case_questions).map((question) => {
                if (question.file_attached !== null) {
                    arrImgContent.push(question.file_attached);
                }
                if (question.case_choices.length > 0) {
                    Object.values(question.case_choices).map((choice) => {
                        return arrImgContent.push(choice.file_attached);
                    });
                }
                return arrImgContent;
            });
            return arrImgContent;
        });
        this.deleteImageToSave(arrImgContent, this.props.listImgAll);

        const partsToPost = Object.values(this.props.caseWillEdit || []).map(p => {
            if (p.type_name === "menjodohkan") {
                return { ...p, random_choice_order: "1" };
            }
            return p;
        });

        const dataToPost = {
            case_parts: partsToPost,
            cases: { ...this.props.cases, class_grade_id: this.state.classGradeId, class_label: this.props.cases.class_label || null },
        };
        axiosInstance
            .post(`/cases/updateExam`, dataToPost)
            .then((response) => {
                // console.log(response);
                this.handleSuccessEdit();
                //
            })
            .catch((error) => {
                if (error.response.status === 500) {
                    this.handleFailureEdit("Terdapat data soal/jawaban kosong", true);
                } else {
                    this.handleFailureEdit(error.message);
                }
            });
    }

    handleSuccessEdit() {
        const alertSuccess = () => (
            <SweetAlert success title="Berhasil!" onConfirm={() => this.handleAlertSuccess()}>
                Soal berhasil diubah !
            </SweetAlert>
        );
        this.setState({
            alertSubmit: alertSuccess(),
        });
    }

    handleAlertSuccess() {
        this.setState({ alertSubmit: null, taskDone: true });
        this.props.changeStatusEdit(true);
    }

    handleFailureEdit(errorMessage, isRequired = false) {
        if (isRequired) {
            this.setState({
                caseStillEmpty: true,
            });
        }
        const alertFailure = () => (
            <SweetAlert warning title="Proses Gagal!" onConfirm={() => this.setState({ alertSubmit: null })} onCancel={() => this.setState({ alertSubmit: null })}>
                {errorMessage}
            </SweetAlert>
        );
        this.setState({
            alertSubmit: alertFailure(),
        });
    }

    getIndex(key, stateData) {
        var index = stateData
            .map(function (item) {
                return item.key;
            })
            .indexOf(key);
        return index;
    }

    handleUpdateCasePart(keyPart, event) {
        var index = this.getIndex(keyPart, this.props.caseWillEdit);
        let text = event.target.value;
        this.props.setNameCasePart(index, text);
    }

    handleUpdateScoreWeight(keyPart, value) {
        let index = this.getIndex(keyPart, this.props.caseWillEdit);
        this.props.setScoreWeight(index, value);
    }

    handleUpdateRandomQuestion(keyPart) {
        let index = this.getIndex(keyPart, this.props.caseWillEdit);
        const currentVal = this.props.caseWillEdit[index].random_question_order;
        const isChecked = currentVal === "1" || currentVal === 1 || currentVal === true;
        const newValue = isChecked ? "0" : "1";
        this.props.editRandomQuestion(index, newValue);
    }

    handleUpdateRandomAnswer(keyPart) {
        let index = this.getIndex(keyPart, this.props.caseWillEdit);
        if (this.props.caseWillEdit[index]?.type_name === "menjodohkan") {
            return;
        }
        const currentVal = this.props.caseWillEdit[index].random_choice_order;
        const isChecked = currentVal === "1" || currentVal === 1 || currentVal === true;
        const newValue = isChecked ? "0" : "1";
        this.props.editRandomAnswer(index, newValue);
    }

    handleUpdateCaseSensitife(keyPart) {
        let index = this.getIndex(keyPart, this.props.caseWillEdit);
        const newValue = parseInt(this.props.caseWillEdit[index].is_case_sensitive) + 1 === 2 ? 0 : 1;
        this.props.editCaseSensitife(index, newValue);
    }

    handleSelectTypeCase(text) {
        if (text === "Uraian") {
            this.props.handleSelectTypeCaseEssay(text, this.props.cases.id);
        } else if (text === "menjodohkan") {
            this.props.handleSelectTypeCaseMenjodohkan(text, this.props.cases.id);
        } else {
            this.props.handleSelectTypeCasePilgan(text, this.props.cases.id);
        }
    }

    render() {
        const caseWillEdit = this.props.caseWillEdit;
        const cases = this.props.cases;
        if (this.state.taskDone === true) {
            localStorage.removeItem("caseWillEdit");
            return <Redirect to="/list-soal" />;
        }

        return (
            <Fragment>
                <Prompt
                    message={JSON.stringify({
                        confirmText: "Ya",
                        messageText: "Apakah Anda yakin keluar? Perubahan Anda akan hilang!",
                        cancelText: "Batal",
                    })}
                />
                <div className="main-panel">
                    <div className="content-wrapper">
                        {caseWillEdit === undefined ? (
                            <div className="d-flex justify-content-center">
                                <img src={Ball} className="img-fluid" alt="" />
                            </div>
                        ) : (
                            <div className="make-soal col-12">
                                <div className="page-header">
                                    <h3 className="page-title">
                                        <span className="page-title-icon bg-gradient-primary text-white mr-2">
                                            <i className="mdi mdi-lead-pencil"></i>
                                        </span>
                                        Edit Soal
                                    </h3>
                                </div>
                                <div className="info-panel d-flex">
                                    <div className="mr-auto p-2">
                                        <h1>{cases.name}</h1>
                                    </div>
                                    {this.props.doingEditCase === false && (
                                        <div className="p-2 d-flex align-self-center" style={{ color: "red" }}>
                                            <div className="alert alert-danger" role="alert">
                                                <i className="mdi mdi-alert-circle mr-1"></i>
                                                Soal ini <b>sudah dikerjakan</b>. Anda <b>tidak dapat Hapus/Tambah</b>
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <div className="row">
                                    <div className="col-12 grid-margin">
                                        <div className="card custom-card-shadow">
                                            <div className="card-body">
                                                {/* get value from case name soal */}
                                                {
                                                    this.state.listClass === null ? (
                                                        <div className="d-flex justify-content-center">
                                                            <img src={Ball} className="img-fluid" alt="loading" />
                                                        </div>
                                                    ) : (
                                                        <>
                                                            <div className="form-group">
                                                                <p className="h4">Pilih Kelas:</p>
                                                                <SelectClass listClass={this.state.listClass} onSelectClass={(e) => this.handleClassChange(e)} defaultValue={this.state.classGradeId || this.props.cases?.class_grade_id} />
                                                            </div>
                                                        </>
                                                    )
                                                }
                                                <div className="form-group">
                                                    <p className="h4">Nama Soal:</p>
                                                    <input id="questionName" type="text" className="form-control inputQuestion darkLine" style={{ fontSize: "1rem" }} placeholder="Masukan Nama Soal Terlebih Dahulu" value={cases.name} onChange={(e) => this.props.editNameCase(e.target.value)} required></input>
                                                </div>
                                                <div className="dropdown-divider"></div>
                                                {/* form soal */}
                                                <form onSubmit={(e) => this.handleSubmit(e)} className="mb-4">
                                                    {/* tipe soal head */}
                                                    <div className="form-group form-group-tipe-soal mt-2">
                                                        <p className="h4">Tipe Soal</p>
                                                        <div className="d-flex flex-wrap">
                                                            <select value={this.props.currentItemTypeCase.typeName} className="custom-select mr-sm-2 darkLine" id="chooseTypeQuestion" style={{ width: "15%" }} onChange={(e) => this.handleSelectTypeCase(e.target.value)} disabled={!this.props.doingEditCase}>
                                                                <option value="">Pilih</option>
                                                                <option value="pilihan ganda">Pilihan Ganda</option>
                                                                <option value="uraian">Uraian</option>
                                                                <option value="pilihan ganda kompleks">Pilihan Ganda Kompleks</option>
                                                                <option value="isian singkat">Isian Singkat</option>
                                                                <option value="pilihan ganda benar salah">Pilihan Ganda Benar Salah</option>
                                                                <option value="menjodohkan">Menjodohkan</option>
                                                            </select>

                                                            <button type="submit" className="btn btn-gradient-primary mr-2 " onClick={this.addItem} disabled={this.props.currentItemTypeCase.type_name === "" ? true : false}>
                                                                + Tambah
                                                            </button>

                                                            <button
                                                                type="button"
                                                                className="btn btn-outline-info"
                                                                onClick={() => this.setState({ showBankSoalModal: true })}
                                                                disabled={!this.props.doingEditCase}
                                                            >
                                                                <i className="mdi mdi-cloud-download mr-1"></i> Ambil dari Bank Soal
                                                            </button>

                                                            {this.state.showBankSoalModal && (
                                                                <BankSoalModal
                                                                    show={this.state.showBankSoalModal}
                                                                    onHide={() => this.setState({ showBankSoalModal: false })}
                                                                    idCourse={this.props.cases.course_id}
                                                                    idSchool={this.props.cases.school_id}
                                                                />
                                                            )}
                                                        </div>
                                                    </div>

                                                    {/* here check view edit part */}
                                                    {Object.values(caseWillEdit).map((member, index) => (
                                                        <div key={member.key}>
                                                            <div className="mb-3">
                                                                <h3 className="font-weight-bolder section-title d-inline">
                                                                    Bagian {index + 1}.
                                                                    {/* {member.case_questions[0].case_choices
																		.length === 0
																		? " Uraian"
																		: " Pilihan Ganda"} */}
                                                                    {member.type_name === "uraian" ? "Uraian" : member.type_name === "pilihan ganda" ? "Pilihan Ganda" : member.type_name === "pilihan ganda kompleks" ? "Pilihan Ganda Kompleks" : member.type_name === "pilihan ganda benar salah" ? "Pilihan Ganda Benar Salah" : member.type_name === "menjodohkan" ? "Menjodohkan" : "Isian Singkat"}
                                                                </h3>
                                                                <button type="submit" className="btn btn-gradient-danger btn-sm float-right" onClick={(e) => this.deleteItem(e, member.key)} disabled={!this.props.doingEditCase}>
                                                                    Hapus
                                                                </button>
                                                            </div>
                                                            {/* head nama BAB */}
                                                            <div className="form-group row">
                                                                <h3 className="col-sm-2 col-form-label h4 ">Nama Bab :</h3>
                                                                <div className="col-sm-10">
                                                                    <textarea
                                                                        className="form-control darkLine"
                                                                        id={"inputDesc" + member.id}
                                                                        rows="3"
                                                                        placeholder="Tulis Nama Bab. Contoh: Bab Perkalian"
                                                                        value={member.name}
                                                                        onChange={(event) => {
                                                                            this.handleUpdateCasePart(member.key, event);
                                                                        }}
                                                                        required
                                                                    ></textarea>
                                                                </div>
                                                                <h3 className="col-sm-2 col-form-label h4 mt-1">Bobot Nilai :</h3>
                                                                <div className="col-sm-10 row">
                                                                    <div className="col-sm-auto mt-4">
                                                                        <div style={{ minWidth: "300px", color: "black" }}>
                                                                            {(() => {
                                                                                const currentWeight = Number(member.score_weight);
                                                                                const isFirstOfType = Object.values(caseWillEdit).findIndex(p => p.type_name === member.type_name) === index;
                                                                                return (
                                                                                    <>
                                                                                        <input 
                                                                                            type="number" 
                                                                                            className="form-control" 
                                                                                            min="0" 
                                                                                            step="1" 
                                                                                            value={currentWeight} 
                                                                                            onChange={(e) => this.handleUpdateScoreWeight(member.key, e.target.value)} 
                                                                                            placeholder="Bobot per soal" 
                                                                                            disabled={!isFirstOfType}
                                                                                        />
                                                                                        <small className="text-muted d-block" style={{ marginTop: "5px" }}>
                                                                                            {isFirstOfType 
                                                                                                ? "Bobot untuk setiap butir soal pada bagian ini." 
                                                                                                : "Bobot dikunci mengikuti Bagian pertama dengan tipe soal yang sama."}
                                                                                        </small>
                                                                                    </>
                                                                                );
                                                                            })()}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <h3 className="col-sm-2 col-form-label h4 ">PIlih Opsi:</h3>
                                                                <div className="col-sm-10 form-inline mb-4">
                                                                    <div className="form-check  mr-5">
                                                                        <input
                                                                            type="checkbox"
                                                                            id={`is-random-question-${member.key}`}
                                                                            className="form-check-input"
                                                                            onChange={() => {
                                                                                this.handleUpdateRandomQuestion(member.key);
                                                                            }}
                                                                            checked={member.random_question_order === "1" || member.random_question_order === 1 || member.random_question_order === true}
                                                                        />
                                                                        <label className="h5" htmlFor={`is-random-question-${member.key}`}>
                                                                            <b>Acak Soal</b>
                                                                        </label>
                                                                    </div>

                                                                    {(member.type_name === "pilihan ganda benar salah" || member.type_name === "menjodohkan" || member.type_name === "pilihan ganda kompleks" || member.type_name === "pilihan ganda") && (
                                                                        <div className="form-check mx-sm-2">
                                                                            <input
                                                                                type="checkbox"
                                                                                id={`is-random-choice-${member.key}`}
                                                                                className="form-check-input"
                                                                                disabled={member.type_name === "menjodohkan"}
                                                                                onChange={() => {
                                                                                    if (member.type_name !== "menjodohkan") {
                                                                                        this.handleUpdateRandomAnswer(member.key);
                                                                                    }
                                                                                }}
                                                                                checked={member.type_name === "menjodohkan" ? true : (member.random_choice_order === "1" || member.random_choice_order === 1 || member.random_choice_order === true)}
                                                                            />
                                                                            <label className="h5" htmlFor={`is-random-choice-${member.key}`}>
                                                                                <b>Acak Jawaban</b>
                                                                                {member.type_name === "menjodohkan" && (
                                                                                    <small className="text-muted ml-1">(Wajib diacak)</small>
                                                                                )}
                                                                            </label>
                                                                        </div>
                                                                    )}
                                                                    {member.type_name === "isian singkat" && (
                                                                        <div className="form-check mx-sm-2">
                                                                            <input
                                                                                type="checkbox"
                                                                                id={`is-case-sensitive-${member.key}`}
                                                                                className="form-check-input"
                                                                                onChange={() => {
                                                                                    this.handleUpdateCaseSensitife(member.key);
                                                                                }}
                                                                                checked={member.is_case_sensitive === 1 ? true : false}
                                                                            />
                                                                            <label for={`is-case-sensitive-${member.key}`}>
                                                                                <b>Case Sensitive</b>
                                                                            </label>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>

                                                            <Question
                                                                member={member}
                                                                indexCasePart={this.getIndex(member.key, this.props.caseWillEdit)}
                                                                stillEmpty={this.state.caseStillEmpty}
                                                                tipePenilaian={this.state.tipePenilaian}
                                                                listKd={this.state.listKd}
                                                                typeCase={
                                                                    // member.case_questions[0].case_choices.length
                                                                    member.type_name
                                                                }
                                                            />
                                                        </div>
                                                    ))}
                                                    <div className="dropdown-divider mt-5 mb-5 "></div>
                                                    {/* btn submit */}
                                                    <div className="mt-4">
                                                        <button type="submit" disabled={this.props.doingEditCase === false} className="btn btn-success btn-lg btn-block">
                                                            Selesai
                                                        </button>
                                                        {this.state.alertSubmit}
                                                    </div>
                                                </form>
                                                <Footer />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        cases: state.Exam.cases,
        currentItemTypeCase: state.Exam.currentItemCase,
        caseWillEdit: state.Exam.case_part,
        doingEditCase: state.Exam.doingEditCase,
        listImgAll: state.Exam.listImg,
        userId: state.User.dataTeacher?.user?.data_employee?.employee_id || state.User.dataTeacher?.user?.user_id,
        roleId: state.User.dataTeacher?.user?.role_id,
        schoolId: state.User.dataSchool?.value,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        loadCaseWillEdit: (cases, case_parts) => dispatch(loadCaseWillEdit(cases, case_parts)),
        editNameCase: (newName) => dispatch(editNameCase(newName)),
        setNameCasePart: (xPart, newPartName) => dispatch(setNameCasePart(xPart, newPartName)),
        setScoreWeight: (xPart, newScore) => dispatch(setScoreWeight(xPart, newScore)),
        editRandomQuestion: (xPart, newValue) => dispatch(editRandomQuestion(xPart, newValue)),
        editRandomAnswer: (xPart, newValue) => dispatch(editRandomAnswer(xPart, newValue)),
        editCaseSensitife: (xPart, newValue) => dispatch(editCaseSensitife(xPart, newValue)),
        handleSelectTypeCaseMenjodohkan: (text, case_id) => dispatch(handleSelectTypeCaseMenjodohkan(text, case_id)),

        handleSelectTypeCaseEssay: (text, case_id) => dispatch(handleSelectTypeCaseEssay(text, case_id)),
        handleSelectTypeCasePilgan: (text, case_id) => dispatch(handleSelectTypeCasePilgan(text, case_id)),
        addCasePart: (casePart, nameExam) => dispatch(addCasePart(casePart, nameExam)),
        deleteCasePart: (part) => dispatch(deleteItem(part)),
        changeStatusEdit: (status) => dispatch(changeStatusEdit(status)),
        handleSelectClass: (classSelected) => dispatch(handleSelectClass(classSelected)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(EditCase);
